/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */
;(function EnergyCalculatorObservation() {
    /**
     * handle the functionality of the sticky sidebar
     *
     * @constructor
     */
    function EnergyCalculatorObservation(dom) {
        /**
         * local object availability
         * @type {EnergyCalculatorObservation}
         * @private
         */
        var _this = this

        /**
         * this.doms
         * @type {Element}
         */
        this.dom = dom

        /**
         * stickySidebar
         * @type {Element}
         */
        this.stickySidebar = document.querySelector("[data-js='sticky-sidebar']")

        /**
         * options
         * @type {Object}
         */
        this.options = {
            rootMargin: '0px',
            threshold: 0.25, // 0 to 1.0
        }

        /**
         * onIntersection
         * @param entries {object}
         * @returns {undefined}
         */
        this.onIntersection = function (entries) {
            for (var i = 0; i < entries.length; i++) {
                let hasCollision = entries[i].isIntersecting
                _this.handleStickySidebarCollision(hasCollision)
            }
        }

        /**
         * stickySidebar collision handling
         */
        this.handleStickySidebarCollision = function (hasCollision) {
            // if sticky sidebar is not present then do nothing
            if (!_this.stickySidebar) return false

            if (hasCollision) {
                _this.stickySidebar.classList.add('js__hidden-mobile--if-energy-calculator-is-in-viewport')
            } else {
                _this.stickySidebar.classList.remove('js__hidden-mobile--if-energy-calculator-is-in-viewport')
            }

            return true
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            // IntersectionObserver

            // create new IntersectionObserver instance, preparing it for callback
            var observer = new IntersectionObserver(this.onIntersection, this.options)
            observer.observe(_this.dom)
        }

        /**
         * initialize call
         */
        this.init()
    }

    // define the global scope
    if (!window.Energy) {
        window.Energy = {}
    }

    window.Energy.EnergyCalculatorObservation = EnergyCalculatorObservation
})()

function initEnergyCalculatorObservation() {
    var energyCalculator = document.querySelector('.js__energy-calculator-observation')
    if (energyCalculator) {
        new window.Energy.EnergyCalculatorObservation(energyCalculator)
    }
}

if (document.readyState !== 'loading') {
    initEnergyCalculatorObservation()
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initEnergyCalculatorObservation()
    })
}
